import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, ViewEncapsulation } from '@angular/core';
import { Coerce } from '@kalidea/kaligraphi';
import { ModeleEnveloppeDto, TypeArrondiModel, TypesRegleEnum } from 'src/graphql/generated-types';
import { TypeActivite } from 'src/app/board/activity/activity.constants';
import {
    ComplementarySubventionInfo
} from 'src/app/_shared/dialogs/shared-advanced-rules/shared-advanced-rule-edit-dialog/shared-advanced-rule-edit-dialog.component';
import { AdvancedRuleService, AdvancedRule } from 'src/app/_shared/services/advanced-rule/advanced-rule.service';
import { BaseComponent } from 'src/app/_core/tools/base.component';

@Component({
    selector: 'app-shared-advanced-rule-detail',
    templateUrl: './shared-advanced-rule-detail.component.html',
    styleUrls: ['./shared-advanced-rule-detail.component.sass'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class SharedAdvancedRuleDetailComponent extends BaseComponent {

    @Coerce('boolean')
    @Input()
    isInteractivity = false;

    @Coerce('boolean')
    @Input()
    isDialog = false;

    @Coerce('boolean')
    @Input()
    isPlanning = false;

    @Input()
    activityType: TypeActivite;

    @Input()
    complementarySubvention?: ComplementarySubventionInfo;

    readonly ruleTypeEnum = TypesRegleEnum;

    readonly subventionLabeli18nSelect = {EPA: 'Abondement', other: 'Subvention'};

    envelopes: ModeleEnveloppeDto[] = this.advancedRuleService.complementaryEnvelopeList;

    readonly roundingI18nSelect = {
        ['+']: 'Arrondi supérieur (plafond)',
        ['-']: 'Arrondi inférieur (plancher)',
        ['=']: 'Arrondi au plus proche'
    };

    private _rule: AdvancedRule;

    roundingType: TypeArrondiModel;

    constructor(protected readonly cdr: ChangeDetectorRef,
                private readonly advancedRuleService: AdvancedRuleService) {
        super(cdr);
    }

    get isSavings(): boolean {
        return this.activityType === TypeActivite.Epargnes;
    }

    get isMediaOrResourcesActivity(): boolean {
        return [TypeActivite.Mediatheque, TypeActivite.RessourcesPartagees].includes(this.activityType);
    }

    get shouldShowSubventionType(): boolean {
        return !!this.complementarySubvention
            && this.rule.TypeRegle === TypesRegleEnum.Subvention
            && !this.isInteractivity
            && this.activityType !== TypeActivite.Epargnes
            && !this.isPlanning;
    }

    get isNotAccessibilityRule(): boolean {
        return this.rule.TypeRegle !== TypesRegleEnum.Accessibilite;
    }

    get rule(): AdvancedRule {
        return this._rule;
    }

    @Input()
    set rule(value: AdvancedRule) {
        this._rule = value;

        this.roundingType = this.advancedRuleService.roundingTypesList.find(({IdTypeArrondi}) => IdTypeArrondi === value.IdTypeArrondi);
    }

}
